(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sa-couples-engraving-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-couples-engraving-variants')) {
  customElements.define('sa-couples-engraving-variants', class extends HTMLElement {
    connectedCallback() {
      if (this.couplesReady) return;
      this.couplesReady = true;
      this.mappingValid = false;
      this.dialog = this.querySelector('[data-sa-cv-dialog]');
      this.terms = this.querySelector('[data-sa-cv-terms]');
      this.saveButton = this.querySelector('[data-sa-cv-save]');
      this.availability = this.querySelector('[data-sa-cv-availability]');
      this.maxLength = Math.min(24, Math.max(1, Number(this.dataset.maxLength) || 24));
      this.rows = ['1', '2'].map(index => ({
        index,
        role: index === '1' ? "Men's watch" : "Women's watch",
        property: this.querySelector(`[data-sa-cv-property="${index}"]`),
        componentProperty: this.querySelector(`[data-sa-cv-component-property="${index}"]`),
        input: this.querySelector(`[data-sa-cv-input="${index}"]`),
        enabled: this.querySelector(`[data-sa-cv-enabled="${index}"]`),
        summary: this.querySelector(`[data-sa-cv-summary="${index}"]`),
        skuLabels: this.querySelectorAll(`[data-sa-cv-sku="${index}"]`),
        openButton: this.querySelector(`[data-sa-cv-open="${index}"]`),
        clearButton: this.querySelector(`[data-sa-cv-clear="${index}"]`),
        removeButton: this.querySelector(`[data-sa-cv-remove="${index}"]`),
        remaining: this.querySelector(`[data-sa-cv-remaining="${index}"]`),
        error: this.querySelector(`[data-sa-cv-error="${index}"]`),
        savedValue: ''
      }));
      this.defaultSummary = this.rows[0].summary.textContent;
      this.rows.forEach(row => {
        row.openButton.hidden = false;
        row.openButton.addEventListener('click', () => this.open(row));
        row.removeButton.addEventListener('click', () => {
          if (!this.mappingValid) return;
          this.commit(row, '');
          this.notify();
        });
        row.enabled.addEventListener('change', () => {
          this.terms.checked = false;
          this.syncDraft();
          if (row.enabled.checked) row.input.focus();
        });
        row.input.addEventListener('input', () => {
          this.terms.checked = false;
          this.syncDraft();
        });
        row.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') event.preventDefault();
        });
        row.clearButton.addEventListener('click', () => {
          row.input.value = '';
          row.enabled.checked = false;
          this.terms.checked = false;
          this.syncDraft();
          row.enabled.focus();
        });
        this.commit(row, '');
      });
      this.querySelectorAll('[data-sa-cv-cancel]').forEach(button => button.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      });
      this.terms.addEventListener('change', () => this.syncDraft());
      this.saveButton.addEventListener('click', () => this.save());
      this.form = this.rows[0].property.form;
      this.form?.addEventListener('reset', () => {
        queueMicrotask(() => {
          this.rows.forEach(row => this.commit(row, ''));
          this.syncDraft();
          this.notify();
        });
      });
      this.productRoot = this.closest('sa-couples-product-variants');
      this.onSelection = event => {
        if (event.target === this.productRoot) this.applyVariantSelection(event.detail);
      };
      this.productRoot?.addEventListener('sa:couples-variants:selection', this.onSelection);
      this.applyVariantSelection(this.productRoot?.couplesVariantSelection || { variantId: '', valid: false, componentSkus: [] });
    }

    applyVariantSelection(selection) {
      if (this.activeVariantId === selection.variantId) return;
      if (this.dialog.open) this.close();
      this.activeVariantId = selection.variantId;
      const components = selection.componentSkus;
      this.mappingValid = Boolean(selection.valid) && Array.isArray(components) && components.length === 2 && components[0] !== components[1] && components.every(sku => /^[A-Za-z0-9][A-Za-z0-9._-]*$/.test(sku));
      this.rows.forEach(row => {
        row.property.disabled = true;
        row.property.removeAttribute('name');
        row.componentProperty.disabled = true;
        row.componentProperty.removeAttribute('name');
      });
      this.rows.forEach((row, index) => {
        const sku = this.mappingValid ? components[index] : '';
        row.skuLabels.forEach(label => { label.textContent = sku; });
        row.property.setAttribute('data-component-sku', sku);
        row.componentProperty.value = this.mappingValid ? `1 × ${sku}` : '';
        row.componentProperty.defaultValue = row.componentProperty.value;
        if (this.mappingValid) {
          row.property.name = `properties[Engraving - ${row.role} (${sku})]`;
          row.componentProperty.name = `properties[${row.role} (per set)]`;
          row.componentProperty.disabled = false;
        }
        row.openButton.disabled = !this.mappingValid;
        row.enabled.disabled = !this.mappingValid;
        this.commit(row, row.savedValue);
      });
      this.availability.hidden = this.mappingValid;
      this.terms.checked = this.mappingValid && this.rows.some(row => Boolean(row.savedValue));
      this.syncDraft();
      this.notify();
    }

    open(row) {
      if (!this.mappingValid) return;
      this.rows.forEach(item => {
        item.input.value = item.savedValue;
        item.enabled.checked = Boolean(item.savedValue);
      });
      this.terms.checked = this.rows.some(item => Boolean(item.savedValue));
      this.syncDraft();
      this.returnFocus = row.openButton;
      this.dialog.showModal();
      (row.enabled.checked ? row.input : row.enabled).focus();
    }

    close() {
      this.dialog.close();
      this.returnFocus?.focus();
    }

    rowError(row) {
      if (!this.mappingValid || !row.enabled.checked) return '';
      const value = row.input.value.trim();
      if (!value) return this.dataset.emptyLabel;
      if (value.length > this.maxLength) return this.dataset.lengthLabel;
      const invalid = [...new Set([...value].filter(character => !/^[A-Za-z0-9 .,!?'&\-]$/.test(character)))].join('');
      return invalid ? `${this.dataset.invalidLabel} ${invalid}` : '';
    }

    syncDraft() {
      let any = false;
      let invalid = false;
      this.rows.forEach(row => {
        const selected = this.mappingValid && row.enabled.checked;
        row.input.disabled = !selected;
        row.clearButton.disabled = !selected;
        row.remaining.textContent = `${Math.max(0, this.maxLength - row.input.value.length)} ${this.dataset.remainingLabel}`;
        const error = this.rowError(row);
        row.error.textContent = error;
        row.error.hidden = !error;
        row.input.setAttribute('aria-invalid', error ? 'true' : 'false');
        any ||= selected;
        invalid ||= Boolean(error);
      });
      this.terms.disabled = !any;
      const missingTerms = any && !this.terms.checked;
      const termsError = this.querySelector('[data-sa-cv-terms-error]');
      termsError.textContent = missingTerms ? this.dataset.requiredTerms : '';
      termsError.hidden = !missingTerms;
      this.saveButton.disabled = !this.mappingValid || invalid || missingTerms;
    }

    commit(row, value) {
      row.savedValue = value;
      row.property.value = value;
      row.property.disabled = !this.mappingValid || !value;
      row.summary.textContent = value || this.defaultSummary;
      row.removeButton.hidden = !this.mappingValid || !value;
      row.input.value = value;
      row.enabled.checked = Boolean(value);
    }

    save() {
      this.syncDraft();
      if (this.saveButton.disabled) return;
      this.rows.forEach(row => this.commit(row, row.enabled.checked ? row.input.value.trim() : ''));
      this.notify();
      this.close();
    }

    notify() {
      this.rows.forEach(row => {
        row.property.dispatchEvent(new Event('change', { bubbles: true }));
        row.componentProperty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.dispatchEvent(new CustomEvent('sa:couples-variants:engraving', { bubbles: true }));
      const status = this.querySelector('[data-sa-cv-status]');
      status.textContent = this.mappingValid ? this.rows.map(row => row.savedValue ? `${row.property.name.slice(11, -1)}: ${row.savedValue}` : '').filter(Boolean).join('. ') : '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sa-couples-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-couples-engraving')) {
    customElements.define('sa-couples-engraving', class extends HTMLElement {
      connectedCallback() {
        if (this.couplesReady) return;
        this.couplesReady = true;
        this.dialog = this.querySelector('[data-sa-couples-dialog]');
        this.terms = this.querySelector('[data-sa-couples-terms]');
        this.saveButton = this.querySelector('[data-sa-couples-save]');
        this.maxLength = Math.min(24, Math.max(1, Number(this.dataset.maxLength) || 24));
        this.rows = ['1', '2'].map(index => ({
          index,
          property: this.querySelector(`[data-sa-couples-property="${index}"]`),
          input: this.querySelector(`[data-sa-couples-input="${index}"]`),
          enabled: this.querySelector(`[data-sa-couples-enabled="${index}"]`),
          summary: this.querySelector(`[data-sa-couples-summary="${index}"]`),
          openButton: this.querySelector(`[data-sa-couples-open="${index}"]`),
          clearButton: this.querySelector(`[data-sa-couples-clear="${index}"]`),
          removeButton: this.querySelector(`[data-sa-couples-remove="${index}"]`),
          remaining: this.querySelector(`[data-sa-couples-remaining="${index}"]`),
          error: this.querySelector(`[data-sa-couples-error="${index}"]`)
        }));
        this.defaultSummary = this.rows[0].summary.textContent;
        this.rows.forEach(row => {
          row.openButton.hidden = false;
          row.openButton.addEventListener('click', () => this.open(row));
          row.removeButton.addEventListener('click', () => {
            this.commit(row, '');
            this.notify();
          });
          row.enabled.addEventListener('change', () => {
            this.terms.checked = false;
            this.syncDraft();
            if (row.enabled.checked) row.input.focus();
          });
          row.input.addEventListener('input', () => {
            this.terms.checked = false;
            this.syncDraft();
          });
          row.input.addEventListener('keydown', event => {
            if (event.key === 'Enter') event.preventDefault();
          });
          row.clearButton.addEventListener('click', () => {
            row.input.value = '';
            row.enabled.checked = false;
            this.terms.checked = false;
            this.syncDraft();
            row.enabled.focus();
          });
          this.commit(row, '');
        });
        this.querySelectorAll('[data-sa-couples-cancel]').forEach(button => button.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.close();
        });
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
          }
        });
        this.terms.addEventListener('change', () => this.syncDraft());
        this.saveButton.addEventListener('click', () => this.save());
        this.form = this.rows[0].property.form;
        this.form?.addEventListener('reset', () => {
          queueMicrotask(() => {
            this.rows.forEach(row => this.commit(row, ''));
            this.notify();
          });
        });
        this.syncDraft();
      }

      open(row) {
        this.rows.forEach(item => {
          item.input.value = item.property.value;
          item.enabled.checked = Boolean(item.property.value);
        });
        this.terms.checked = this.rows.some(item => Boolean(item.property.value));
        this.syncDraft();
        this.returnFocus = row.openButton;
        this.dialog.showModal();
        (row.enabled.checked ? row.input : row.enabled).focus();
      }

      close() {
        this.dialog.close();
        this.returnFocus?.focus();
      }

      rowError(row) {
        if (!row.enabled.checked) return '';
        const value = row.input.value.trim();
        if (!value) return this.dataset.emptyLabel;
        if (value.length > this.maxLength) return this.dataset.lengthLabel;
        const invalid = [...new Set([...value].filter(character => !/^[A-Za-z0-9 .,!?'&\-]$/.test(character)))].join('');
        return invalid ? `${this.dataset.invalidLabel} ${invalid}` : '';
      }

      syncDraft() {
        let any = false;
        let invalid = false;
        this.rows.forEach(row => {
          const selected = row.enabled.checked;
          row.input.disabled = !selected;
          row.clearButton.disabled = !selected;
          row.remaining.textContent = `${Math.max(0, this.maxLength - row.input.value.length)} ${this.dataset.remainingLabel}`;
          const error = this.rowError(row);
          row.error.textContent = error;
          row.error.hidden = !error;
          row.input.setAttribute('aria-invalid', error ? 'true' : 'false');
          any ||= selected;
          invalid ||= Boolean(error);
        });
        this.terms.disabled = !any;
        const missingTerms = any && !this.terms.checked;
        const termsError = this.querySelector('[data-sa-couples-terms-error]');
        termsError.textContent = missingTerms ? this.dataset.requiredTerms : '';
        termsError.hidden = !missingTerms;
        this.saveButton.disabled = invalid || missingTerms;
      }

      commit(row, value) {
        row.property.value = value;
        row.property.disabled = !value;
        row.summary.textContent = value || this.defaultSummary;
        row.removeButton.hidden = !value;
        row.input.value = value;
        row.enabled.checked = Boolean(value);
      }

      save() {
        this.syncDraft();
        if (this.saveButton.disabled) return;
        this.rows.forEach(row => this.commit(row, row.enabled.checked ? row.input.value.trim() : ''));
        this.notify();
        this.close();
      }

      notify() {
        this.rows.forEach(row => row.property.dispatchEvent(new Event('change', { bubbles: true })));
        this.dispatchEvent(new CustomEvent('sa:couples-engraving:change', { bubbles: true }));
        const status = this.querySelector('[data-sa-couples-status]');
        status.textContent = this.rows.map(row => row.property.value ? `${row.property.name.slice(11, -1)}: ${row.property.value}` : '').filter(Boolean).join('. ');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
